import { arrayPush, change, clearSubmitErrors, destroy, reset } from 'redux-form'

export const changeForm = change
export const clearFormSubmitErrors = clearSubmitErrors
export const destroyForm = destroy
export const formArrayPush = arrayPush
export const resetForm = reset
